import React, { useState } from 'react';
import { Box, Heading, Text, Button, Tag, TextLink } from '@indeed/ifl-components';
import { usePageFlow } from '../../../lib/pageFlow/usePageFlow';
import { RadioCardGroup } from '../../../components/ResumeRadioCard/RadioCardGroup';
import { Hide, Show } from '@indeed/ifl-icons';
import { RadioCardLabel } from '../../../components/ResumeRadioCard/RadioCardLabel';
import { ScoutRadioCard } from '../../../components/ScoutRadioCard/ScoutRadioCard';
import PageTransition from '../../../components/PageTransition/PageTransition';

const ScoutSettingPage: React.FC = () => {
    const { goForward } = usePageFlow();

    // Local state for scout settings (no GraphQL schema found as requested)
    const [scoutPreference, setScoutPreference] = useState<boolean>(true);

    const handleOptionSelect = (option: boolean) => {
        setScoutPreference(option);
    };

    const handleNext = () => {
        // TODO: In a real implementation, save scout preference to server
        void goForward(); // Uses flow-aware navigation to next step
    };

    return (
        <PageTransition pageKey="light-apply-scout-setting">
            <Box sx={{ inlineSize: '100%' }}>
                <Box sx={{ marginBlockEnd: '32px' }}>
                    <Heading level={2} sx={{ marginBlockEnd: '8px', fontSize: '24px' }}>
                        プロフィールを公開して、スカウトを受けてみませんか？
                    </Heading>
                </Box>
                <Box
                    sx={{
                        marginBlockEnd: '32px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '32px',
                    }}
                >
                    <RadioCardGroup
                        variant="check"
                        sx={{ marginBlock: 4 }}
                        name="searchable"
                        selectedValue={scoutPreference.toString()}
                        onChange={(e) => handleOptionSelect(e.target.value === 'true')}
                    >
                        <ScoutRadioCard
                            value="true"
                            id="scout-visible"
                            data-testid="ScoutResume-VisibleRadio"
                        >
                            <RadioCardLabel
                                icon={<Show aria-hidden />}
                                title={
                                    <Box>
                                        <Text sx={{ color: 'background.primary' }}>
                                            {'希望する (匿名)'}
                                        </Text>
                                        <Tag sx={{ marginInlineStart: 2 }}>{'推奨'}</Tag>
                                    </Box>
                                }
                                variant={scoutPreference == true ? 'check' : 'none'}
                                radioCardInputId="scout-visible-input"
                            >
                                <Text level={2} sx={{ color: 'foreground.weak' }}>
                                    採用企業にプロフィールの閲覧とスカウトメールの送信を許可します。応募するまで氏名、住所、電話番号は公開されませんのでご安心ください。履歴書の利用目的の詳細は画面下部をご覧ください※。
                                </Text>
                            </RadioCardLabel>
                        </ScoutRadioCard>
                        <ScoutRadioCard
                            value="false"
                            id="scout-private"
                            data-testid="ScoutResume-HiddenRadio"
                        >
                            <RadioCardLabel
                                icon={<Hide aria-hidden />}
                                title={
                                    <Text sx={{ color: 'background.primary' }}>{'希望しない'}</Text>
                                }
                                variant={scoutPreference == false ? 'check' : 'none'}
                                radioCardInputId="scout-private-input"
                            >
                                <Text level={2} sx={{ color: 'foreground.weak' }}>
                                    {'応募企業にのみIndeed履歴書の閲覧を許可します。'}
                                </Text>
                            </RadioCardLabel>
                        </ScoutRadioCard>
                    </RadioCardGroup>

                    <Box sx={{ marginBlockStart: '24px' }}>
                        <Text sx={{ color: 'foreground.weak', fontSize: '14px' }}>
                            ※(1)
                            採用企業によるプロフィールの検索・閲覧およびスカウトメール送信のために、Indeedが
                            <TextLink href="https://www.indeed.com" target="_blank">
                                一定の条件
                            </TextLink>
                            でIndeed履歴書を含むプロフィールを採用企業に開示すること、ならびに(2)
                            スカウトメールその他Indeedを通じて送受信されるすべてのやりとりが{' '}
                            <TextLink
                                href="https://www.indeed.com/legal/terms-of-use"
                                target="_blank"
                            >
                                Indeedの利用規約
                            </TextLink>{' '}
                            および{' '}
                            <TextLink
                                href="https://www.indeed.com/legal/privacy-policy"
                                target="_blank"
                            >
                                プライバシー規約
                            </TextLink>{' '}
                            に従ってサービス改善等の目的で処理および分析されることに同意します。
                        </Text>
                    </Box>

                    <Box sx={{ marginBlockStart: '24px' }}>
                        <Button
                            variant="primary"
                            size="lg"
                            sx={{ inlineSize: '100%', marginBlockEnd: '16px' }}
                            onClick={handleNext}
                        >
                            次へ
                        </Button>
                    </Box>
                </Box>
            </Box>
        </PageTransition>
    );
};

export default ScoutSettingPage;
